:host {
  display: flex;
  height: auto;
  max-height: 100%;
  --content-dynamic-height: auto;
}

.hide-button-container {
  display: none;
}

.button-container {
  display: flex;
  justify-content: center;
  margin: var(--spacer) 0;
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: var(--body-text-arrows-400);
}

.slot-container {
  overflow: hidden;
  max-height: var(--content-dynamic-height);
}

.clamped {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: var(--content-clamp-number, 2);
  -webkit-box-orient: vertical;
}

@supports (background: -webkit-named-image(i)) {
  .slot-container {
    max-height: calc(var(--content-dynamic-height + 12px));
  }
}

.phasr-description-button::part(button-text) {
  --font-family: "IBMPlexSans", "IBM Plex Sans", sans-serif;
  font-weight: 400;
}
